import { use, useState } from "react";
import PrimaryButton from "../buttons/PrimaryButton";

export const SubscribeButton = () => {
  const [subscribe_hovering, setSubscribeHovering] = useState(false);
  const isphone = window.innerWidth < 768;
  const [display, setDisplay] = useState(false);
  return (
    <>
      {isphone ? (
        <>
          {display && (
            <div
              onClick={() => setDisplay(false)}
              className="fixed bottom-0 i left-0 h-screen w-screen  z-10 backdrop-blur-sm"
            ></div>
          )}
          <div className="fixed bottom-6 right-2 mx-4 bg-wshadow_75 hover:shadow-lg hover:shadow-shadow_10  hover:bg-white z-20 hover:border-2 duration-300 transition-all mb-4 backdrop-blur-md border-1 p-2 border-white rounded-2xl flex flex-col w-fit h-fit  items-center justify-center ">
            {display ? (
              <>
                <div className="flex flex-row gap-2 items-center justify-center w-fit">
                  <SubscribeButtonHTML />
                </div>

                <div className="text-h4 mt-2 font-medium text-neutral-400 maw-w-c400 w-full">
                  Vous recevrez une notification par e-mail dès qu’une nouvelle
                  FAQ est publiée.
                </div>
              </>
            ) : (
              <>
                <PrimaryButton onClick={() => setDisplay(true)}>
                  S'abonner
                </PrimaryButton>
              </>
            )}
          </div>
        </>
      ) : (
        <>
          {subscribe_hovering && (
            <div className="fixed bottom-0 left-0 h-screen w-screen  z-10 backdrop-blur-sm"></div>
          )}
          <div
            onMouseEnter={() => setSubscribeHovering(true)}
            onMouseLeave={() => setSubscribeHovering(false)}
            className="fixed bottom-6 mx-4 bg-wshadow_75 hover:shadow-lg hover:shadow-shadow_10  hover:bg-white z-20 hover:border-2 duration-300 transition-all mb-4 backdrop-blur-md border-1 p-2 border-white rounded-2xl flex flex-col w-fit h-fit  items-center justify-center "
          >
            <div className="flex flex-row gap-2 items-center justify-center w-fit">
              <SubscribeButtonHTML />
            </div>

            {subscribe_hovering && (
              <div
                className="text-h4 mt-2 font-medium text-neutral-400  "
                style={{ maxWidth: "330px" }}
              >
                Vous recevrez une notification par e-mail dès qu’une nouvelle
                FAQ est publiée.
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export function SubscribeButtonHTML() {
  return <div dangerouslySetInnerHTML={{ __html: html_code }} />;
}

const html_code = `

<style>@import url('https://fonts.googleapis.com/css2?family=Inter&display=swap');</style><div class="newsletter-form-container"><form class="newsletter-form" action="https://app.loops.so/api/newsletter-form/cmdvr3t59imdz2g0ifo3hpyid" method="POST" style="display: flex; flex-direction: row; align-items: center; justify-content: center; width: 100%;"><input class="newsletter-form-input" name="newsletter-form-input" type="email" placeholder="jean@gmail.com" required="" style="font-family: Inter, sans-serif; color: rgb(0, 0, 0); font-size: 14px; margin: 0px 10px 0px 0px; width: 100%; max-width: 300px; min-width: 100px; background: rgb(255, 255, 255); border: 1px solid rgb(209, 213, 219); box-sizing: border-box; box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px; border-radius: 6px; padding: 8px 12px;"><button type="submit" class="newsletter-form-button" style="background: rgb(0, 0, 0); font-size: 14px; color: rgb(255, 255, 255); font-family: Inter, sans-serif; display: flex; width: min-content; max-width: 300px; white-space: nowrap; height: 38px; align-items: center; justify-content: center; flex-direction: row; padding: 9px 17px; box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px; border-radius: 6px; text-align: center; font-style: normal; font-weight: 500; line-height: 20px; border: none; cursor: pointer;">S'abonner</button><button type="button" class="newsletter-loading-button" style="background: rgb(0, 0, 0); font-size: 14px; color: rgb(255, 255, 255); font-family: Inter, sans-serif; display: none; width: min-content; max-width: 300px; white-space: nowrap; height: 38px; align-items: center; justify-content: center; flex-direction: row; padding: 9px 17px; box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px; border-radius: 6px; text-align: center; font-style: normal; font-weight: 500; line-height: 20px; border: none; cursor: pointer;">Please wait...</button></form><div class="newsletter-success" style="display: none; align-items: center; justify-content: center; width: 100%;"><p class="newsletter-success-message" style="font-family: Inter, sans-serif; color: rgb(0, 0, 0); font-size: 14px;">Vous êtes inscrits !</p></div><div class="newsletter-error" style="display: none; align-items: center; justify-content: center; width: 100%;"><p class="newsletter-error-message" style="font-family: Inter, sans-serif; color: rgb(185, 28, 28); font-size: 14px;">Oops! Something went wrong, please try again</p></div>
<button 
class='newsletter-back-button'
type='button' 
style='color:#6b7280;font: 14px, Inter, sans-serif;margin:10px auto;text-align:center;display:none;background:transparent;border:none;cursor:pointer'
onmouseout='this.style.textDecoration="none"' 
onmouseover='this.style.textDecoration="underline"'>
&larr; Back
</button>
</div><script>
function submitHandler(event) {
  event.preventDefault();
  var container = event.target.parentNode;
  var form = container.querySelector(".newsletter-form");
  var formInput = container.querySelector(".newsletter-form-input");
  var success = container.querySelector(".newsletter-success");
  var errorContainer = container.querySelector(".newsletter-error");
  var errorMessage = container.querySelector(".newsletter-error-message");
  var backButton = container.querySelector(".newsletter-back-button");
  var submitButton = container.querySelector(".newsletter-form-button");
  var loadingButton = container.querySelector(".newsletter-loading-button");
  

  const rateLimit = () => {
    errorContainer.style.display = "flex";
    errorMessage.innerText = "Too many signups, please try again in a little while";
    submitButton.style.display = "none";
    formInput.style.display = "none";
    backButton.style.display = "block";
  }

  // Compare current time with time of previous sign up
  var time = new Date();
  var timestamp = time.valueOf();
  var previousTimestamp = localStorage.getItem("loops-form-timestamp");

  // If last sign up was less than a minute ago
  // display error
  if (previousTimestamp && Number(previousTimestamp) + 60000 > timestamp) {
    rateLimit();
    return;
  }
  localStorage.setItem("loops-form-timestamp", timestamp);

  submitButton.style.display = "none";
  loadingButton.style.display = "flex";

  var formBody = "userGroup=EarlyAccess&mailingLists=&email=" 
    + encodeURIComponent(formInput.value)
    ;

  fetch(event.target.action, {
    method: "POST",
    body: formBody,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  })
    .then((res) => [res.ok, res.json(), res])
    .then(([ok, dataPromise, res]) => {
      if (ok) {
        // If response successful
        // display success
        success.style.display = "flex";
        form.reset();
      } else {
        // If response unsuccessful
        // display error message or response status
        dataPromise.then(data => {
          errorContainer.style.display = "flex";
          errorMessage.innerText = data.message
            ? data.message
            : res.statusText;
        });
      }
    })
    .catch(error => {
      // check for cloudflare error
      if (error.message === "Failed to fetch") {
        rateLimit();
        return;
      }
      // If error caught
      // display error message if available
      errorContainer.style.display = "flex";
      if (error.message) errorMessage.innerText = error.message;
      localStorage.setItem("loops-form-timestamp", '');
    })
    .finally(() => {
      formInput.style.display = "none";
      loadingButton.style.display = "none";
      backButton.style.display = "block";
    });
}
function resetFormHandler(event) {
  var container = event.target.parentNode;
  var formInput = container.querySelector(".newsletter-form-input");
  var success = container.querySelector(".newsletter-success");
  var errorContainer = container.querySelector(".newsletter-error");
  var errorMessage = container.querySelector(".newsletter-error-message");
  var backButton = container.querySelector(".newsletter-back-button");
  var submitButton = container.querySelector(".newsletter-form-button");

  success.style.display = "none";
  errorContainer.style.display = "none";
  errorMessage.innerText = "Oops! Something went wrong, please try again";
  backButton.style.display = "none";
  formInput.style.display = "flex";
  submitButton.style.display = "flex";
}

var formContainers = document.getElementsByClassName(
  "newsletter-form-container"
);

for (var i = 0; i < formContainers.length; i++) {
  var formContainer = formContainers[i]
  var handlersAdded = formContainer.classList.contains('newsletter-handlers-added')
  if (handlersAdded) continue;
  formContainer
    .querySelector(".newsletter-form")
    .addEventListener("submit", submitHandler);
  formContainer
    .querySelector(".newsletter-back-button")
    .addEventListener("click", resetFormHandler);
  formContainer.classList.add("newsletter-handlers-added");
}
</script>
`;
